// /* eslint-disable react-hooks/exhaustive-deps */
// import { useEffect, useRef, useState } from "react";
// import NormalSearch from "../../../components/common/NormalSearch";

// type Props = {
//   ALL_CITIES: any;
//   selectedCityData: any;
//   setSelectedCitiesArray?: (data: any) => void;
//   coverageType?: string;
//   coverageCity?: string;
//   coverageCountry?: string;
//   error?: string;
//   setError?: (data: string) => void;
//   isEdit: boolean;
// };

// const CoverageCities = ({
//   setSelectedCitiesArray,
//   error,
//   setError,
//   isEdit,
//   coverageType,
//   coverageCountry,
//   coverageCity,
//   selectedCityData = [],
//   ALL_CITIES = [],
// }: Props) => {
//   const [selectedCities, setSelectedCities] =
//     useState<string[]>(selectedCityData);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filteredCities, setFilteredCities] = useState(
//     ALL_CITIES?.filter((city: any) =>
//       city?.name?.toLowerCase().includes(searchQuery.toLowerCase())
//     )
//   );
//   useEffect(() => {
//     setFilteredCities(
//       ALL_CITIES?.filter((city: any) =>
//         city?.name?.toLowerCase().includes(searchQuery.toLowerCase())
//       )
//     );
//   }, [coverageType, ALL_CITIES, searchQuery]);

//   useEffect(() => {
//     setSelectedCities([]);
//   }, [coverageType, coverageCountry, coverageCity]);

//   useEffect(() => {
//     if (setSelectedCitiesArray) {
//       setSelectedCitiesArray(selectedCities);
//     }
//     if (selectedCityData?.length > 0 && setError) {
//       setError("");
//     }
//   }, [selectedCities]);

//   useEffect(() => {
//     if (selectedCityData?.length > 0) {
//       setSelectedCities(selectedCityData);
//     }
//   }, [selectedCityData]);

//   const toggleCity = (city: string) => {
//     setSelectedCities((prev: any) =>
//       prev?.includes(city)
//         ? prev.filter((c: any) => c !== city)
//         : [...prev, city]
//     );
//   };

//   const selectAll = () => {
//     setSelectedCities([...ALL_CITIES?.map((city: any) => city?.id)]);
//   };

//   const [visibleCities, setVisibleCities] = useState<any[]>([]);
//   const [cityPage, setCityPage] = useState(1);
//   const listRef = useRef(null);

//   const CITIES_PER_PAGE = 20; // Load 20 cities at a time
//   useEffect(() => {
//     if (filteredCities?.length) {
//       const newCities = filteredCities.slice(0, cityPage * CITIES_PER_PAGE);
//       setVisibleCities(newCities);
//     } else {
//       setVisibleCities([]);
//     }
//   }, [filteredCities, cityPage]);

//   const handleScroll = () => {
//     const container: any = listRef.current;
//     if (!container) return;

//     if (
//       container.scrollTop + container.clientHeight >=
//       container.scrollHeight - 10
//     ) {
//       // Near bottom, load more
//       if (cityPage * CITIES_PER_PAGE < filteredCities.length) {
//         setCityPage((prev) => prev + 1);
//       }
//     }
//   };

//   return (
//     <div>
//       <div className="space-y-4 ">
//         <div className="flex items-center gap-2 w-full ">
//           <NormalSearch
//             className="w-full "
//             value={searchQuery}
//             onChange={(e: any) => setSearchQuery(e.target.value)}
//           />
//         </div>

//         <div className="grid grid-cols-2 gap-4">
//           <div className="border border-[#d2d2d2] rounded-lg">
//             <div className="flex items-center border-b border-[#d2d2d2] justify-between p-2">
//               <h3 className="text-[#1E293B]">
//                 {coverageType?.[0]?.toUpperCase()}
//                 {coverageType?.slice(1)} List{" "}
//                 {visibleCities?.length - (selectedCities?.length || 0) > 0 &&
//                   `(${visibleCities?.length - (selectedCities?.length || 0)})`}
//               </h3>
//               <button
//                 onClick={selectAll}
//                 className="text-[#1E1E1E]/70 text-sm flex items-center space-x-1"
//               >
//                 <label className="relative flex items-center cursor-pointer">
//                   <input
//                     type="checkbox"
//                     checked={ALL_CITIES?.length === selectedCities?.length}
//                     readOnly
//                     className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                                 bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
//                   />
//                   <span
//                     className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                                 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                   >
//                     ✓
//                   </span>
//                 </label>

//                 <span>Select All</span>
//               </button>
//             </div>
//             <div className="space-y-2 max-h-96 overflow-y-auto p-2">
//               <div
//                 className="max-h-[300px] overflow-auto space-y-2"
//                 onScroll={handleScroll}
//                 ref={listRef}
//               >
//                 {visibleCities.map(
//                   (city: any) =>
//                     !selectedCities?.includes(city?.id) && (
//                       <div className="flex items-center gap-2">
//                         <label
//                           key={city?.id}
//                           className="relative flex items-center cursor-pointer"
//                         >
//                           <input
//                             type="checkbox"
//                             checked={selectedCities?.includes(city?.id)}
//                             onChange={() => toggleCity(city?.id)}
//                             disabled={isEdit}
//                             className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                                 bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
//                           />
//                           <span
//                             className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                                 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                           >
//                             ✓
//                           </span>
//                         </label>
//                         <p className="text-sm"> {city?.name}</p>
//                       </div>
//                     )
//                 )}
//               </div>

//               {error && (
//                 <span className="text-red-500 text-sm min-h-[0.5rem] block pl-3">
//                   {error || ""}
//                 </span>
//               )}
//             </div>
//           </div>

//           {/* Right: Coverage Cities */}
//           <div className="border border-[#d2d2d2] rounded-lg">
//             <div className="border-b border-[#d2d2d2]  p-2 flex justify-between items-center">
//               <h3 className="text-[#1E293B]">
//                 Coverage {coverageType?.[0]?.toUpperCase()}
//                 {coverageType?.slice(1)} List
//               </h3>

//               <button className="text-[#1E1E1E]/70 text-sm flex items-center space-x-1">
//                 <label className="relative flex items-center cursor-pointer">
//                   <input
//                     type="checkbox"
//                     readOnly
//                     className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                                 bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
//                   />
//                   <span
//                     className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                                 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                   >
//                     ✓
//                   </span>
//                 </label>

//                 <span>Deselect All</span>
//               </button>
//             </div>
//             <div className="space-y-2 overflow-y-auto p-2 max-h-[300px]">
//               {selectedCities?.map((city) => (
//                 <div className="flex items-center gap-2">
//                   <label
//                     key={city}
//                     className="relative flex items-center cursor-pointer"
//                   >
//                     <input
//                       type="checkbox"
//                       checked
//                       onChange={() => toggleCity(city)}
//                       readOnly
//                       className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037]
//                                 bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
//                     />
//                     <span
//                       className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0
//                                 top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                     >
//                       ✓
//                     </span>
//                   </label>
//                   <p className="text-sm">
//                     {" "}
//                     {ALL_CITIES?.find((e: any) => e?.id === city)?.name}
//                   </p>
//                 </div>
//                 // <div
//                 //   key={city}
//                 //   className="flex items-center px-3 py-1 rounded-lg text-sm"
//                 // >
//                 //   <input
//                 //     type="checkbox"
//                 //     checked
//                 //     onChange={() => toggleCity(city)}
//                 //     readOnly
//                 //     className="mr-2 accent-[#007BFF]"
//                 //   />
//                 //   {ALL_CITIES?.find((e: any) => e?.id === city)?.name}
//                 // </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CoverageCities;

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import NormalSearch from "../../../components/common/NormalSearch";

type Props = {
  ALL_CITIES: any;
  selectedCityData: any;
  setSelectedCitiesArray?: (data: any) => void;
  coverageType?: string;
  coverageCountry?: string;
  coverageCity?: string;
  error?: string;
  setError?: (data: string) => void;
  isEdit: boolean;
};

const CoverageCities = ({
  setSelectedCitiesArray,
  error,
  setError,
  isEdit,
  coverageType,
  coverageCountry,
  coverageCity,
  selectedCityData = [],
  ALL_CITIES = [],
}: Props) => {
  const [selectedCities, setSelectedCities] =
    useState<string[]>(selectedCityData);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCities, setFilteredCities] = useState(
    ALL_CITIES?.filter((city: any) =>
      city?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
    )
  );

  // Filter cities based on search
  useEffect(() => {
    setFilteredCities(
      ALL_CITIES?.filter((city: any) =>
        city?.name?.toLowerCase().includes(searchQuery?.toLowerCase())
      )
    );
  }, [ALL_CITIES, searchQuery]);

  // Reset selected cities when coverage type/country/city changes
  useEffect(() => {
    setSelectedCities([]);
  }, [coverageType, coverageCountry, coverageCity]);

  // Sync with parent via callback
  useEffect(() => {
    if (setSelectedCitiesArray) {
      setSelectedCitiesArray(selectedCities);
    }
    if (selectedCityData?.length > 0 && setError) {
      setError("");
    }
  }, [selectedCities]);

  // Initialize from selectedCityData
  useEffect(() => {
    if (selectedCityData?.length > 0) {
      setSelectedCities(selectedCityData);
    }
  }, [selectedCityData]);

  // Toggle individual city
  const toggleCity = (cityId: string) => {
    setSelectedCities((prev: string[]) =>
      prev.includes(cityId)
        ? prev.filter((c) => c !== cityId)
        : [...prev, cityId]
    );
  };

  // Select all visible (filtered) cities
  const selectAll = () => {
    const visibleCityIds = visibleCities.map((city: any) => city?.id);
    setSelectedCities((prev) => {
      const newSelected = prev.filter((id) => !visibleCityIds.includes(id)); // keep non-visible
      return [...newSelected, ...visibleCityIds];
    });
  };

  // Deselect all cities (global)
  const deselectAll = () => {
    setSelectedCities([]);
  };

  // Pagination / Infinite scroll
  const [visibleCities, setVisibleCities] = useState<any[]>([]);
  const [cityPage, setCityPage] = useState(1);
  const listRef = useRef<HTMLDivElement>(null);

  const CITIES_PER_PAGE = 20;

  useEffect(() => {
    if (filteredCities?.length) {
      const newCities = filteredCities.slice(0, cityPage * CITIES_PER_PAGE);
      setVisibleCities(newCities);
    } else {
      setVisibleCities([]);
    }
  }, [filteredCities, cityPage]);

  const handleScroll = () => {
    const container = listRef.current;
    if (!container) return;

    if (
      container.scrollTop + container.clientHeight >=
      container.scrollHeight - 10
    ) {
      if (cityPage * CITIES_PER_PAGE < filteredCities.length) {
        setCityPage((prev) => prev + 1);
      }
    }
  };

  // Compute counts
  const availableCount = visibleCities.filter(
    (city) => !selectedCities.includes(city?.id)
  ).length;
  const selectedCount = selectedCities.length;

  // Check if all visible cities are selected
  const allVisibleSelected =
    visibleCities.length > 0 &&
    visibleCities.every((city) => selectedCities.includes(city?.id));

  return (
    <div>
      <div className="space-y-4">
        <div className="flex items-center gap-2 w-full">
          <NormalSearch
            className="w-full"
            value={searchQuery}
            onChange={(e: any) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          {/* Left: Available Cities */}
          <div className="border border-[#d2d2d2] rounded-lg">
            <div className="flex items-center border-b border-[#d2d2d2] justify-between p-2">
              <h3 className="text-[#1E293B]">
                {coverageType?.[0]?.toUpperCase()}
                {coverageType?.slice(1)} List{" "}
                {availableCount > 0 && `(${availableCount})`}
              </h3>
              <button
                onClick={selectAll}
                className="text-[#1E1E1E]/70 text-sm flex items-center space-x-1"
                disabled={visibleCities.length === 0}
              >
                <label className="relative flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={allVisibleSelected}
                    readOnly
                    className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                                bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                  />
                  <span
                    className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                                top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                  >
                    ✓
                  </span>
                </label>
                <span>Select All</span>
              </button>
            </div>

            <div className="space-y-2 max-h-96 overflow-y-auto p-2">
              <div
                className="max-h-[300px] overflow-auto space-y-2"
                onScroll={handleScroll}
                ref={listRef}
              >
                {visibleCities.map(
                  (city: any) =>
                    !selectedCities.includes(city?.id) && (
                      <div key={city?.id} className="flex items-center gap-2">
                        <label className="relative flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedCities.includes(city?.id)}
                            onChange={() => toggleCity(city?.id)}
                            disabled={isEdit}
                            className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                                        bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                          />
                          <span
                            className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                                        top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                          >
                            ✓
                          </span>
                        </label>
                        <p className="text-sm">{city?.name}</p>
                      </div>
                    )
                )}
              </div>

              {error && (
                <span className="text-red-500 text-sm min-h-[0.5rem] block pl-3">
                  {error}
                </span>
              )}
            </div>
          </div>

          {/* Right: Selected Coverage Cities */}
          <div className="border border-[#d2d2d2] rounded-lg">
            <div className="border-b border-[#d2d2d2] p-2 flex justify-between items-center">
              <h3 className="text-[#1E293B]">
                Coverage {coverageType?.[0]?.toUpperCase()}
                {coverageType?.slice(1)} List{" "}
                {selectedCount > 0 && `(${selectedCount})`}
              </h3>

              <button
                onClick={deselectAll}
                className="text-[#1E1E1E]/70 text-sm flex items-center space-x-1"
                disabled={selectedCount === 0}
              >
                <label className="relative flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={selectedCount > 0}
                    readOnly
                    className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                                bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                  />
                  <span
                    className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                                top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                  >
                    ✓
                  </span>
                </label>
                <span>Deselect All</span>
              </button>
            </div>

            <div className="space-y-2 overflow-y-auto p-2 max-h-[300px]">
              {selectedCities.map((cityId) => {
                const city = ALL_CITIES?.find((c: any) => c?.id === cityId);
                return city ? (
                  <div key={cityId} className="flex items-center gap-2">
                    <label className="relative flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked
                        onChange={() => toggleCity(cityId)}
                        readOnly
                        className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                                    bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                      />
                      <span
                        className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                                    top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                      >
                        ✓
                      </span>
                    </label>
                    <p className="text-sm">{city.name}</p>
                  </div>
                ) : null;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoverageCities;
